import { FC } from "react";

import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { CopySendArrowIcon } from "mds/icons";
import { useClassActions } from "utils/class-utils";

const LeaveClassButton: FC = () => {
  const { leaveClass } = useClassActions();

  return (
    <Button
      className="bg-red-shade-20 text-white group-data-[dark]/themable:bg-red-shade-20 group-data-[dark]/themable:text-white"
      kind="squareLegacy"
      size="l"
      title={t("av.leave_virtual_class")}
      isSquare
      onClick={leaveClass}
    >
      <CopySendArrowIcon />
    </Button>
  );
};

// Using default export to allow lazy-loading
// eslint-disable-next-line import/no-default-export
export default LeaveClassButton;
